'use strict';

import modalDirective from 'brg/rest/buttons/modal';
import resolveUsers from 'utils/resolve/users';

import template from './template.html';

export default modalDirective({
	template: template,
	controller: controller,
	resolve: {
		users: resolveUsers,
	}
});


function controller($scope, $http) {
	'ngInject';

	$scope.submitting = false;
	$scope.errors = null;

	$scope.submitData = function() {
		if ($scope.submitting) return;
		$scope.submitting = true;
		const url = '/api/teams/beats/reserve_lists/append_user/';
		const data = {
			reserve_list_id: $scope.$context.reserve_list.uuid,
			user_id: $scope.selectedUser.uuid,
		};

		$http({
			method: 'POST',
			url: url,
			data: data,
		}).then((response) => {
			$scope.$close(response.data);
		}, (error) => {
			console.error(error);
			$scope.errors = error.data;
		}).finally(() => {
			$scope.submitting = false;
		});
	}
}
